<template>
   <div class="wrapper">
      <div class="animated fadeIn ">
        <!-- FirstMile -->
        <!-- <div > -->
          <b-row>
            <b-col cols="12">
              <b-breadcrumb :items="breadcrumbs" />
              <!-- Code added -->
              <b-card
                header-tag="header"
                footer-tag="footer"
                style="margin-bottom:0px;"
              >
              <!-- :class="{'show--height': pickuplocationmasterid =='' || pickuplocationmasterid=='365', 'notshow--height': pickuplocationmasterid!='365'}" -->
              <!-- style=" margin-bottom: 0px; height:100vh;" -->
              <div style="display: block;">
                <div id="overlayOTP" >
                  <div class="loaderOTP"></div>
                </div>

                <b-row>
                 <b-col md="4">
               <b-form-group label="Pick-up Id"  :label-cols="4" >
                 
                  <vue-tags-input
                    v-model="pickupId" 
                    :tags="tags"
                    @tags-changed="newTags => tags = newTags  "
                    :avoidAddingDuplicates="avoidAddingDuplicates"
                    :placeholder="placeholder"
                     v-bind:separators="[',', ';']"
                    ref="taginput"
                    />
                    <span class="badge badge-success1">&nbsp;</span>&nbsp;
                    <label :label-cols="4" >Unique Shipping Id</label><br>
                    <span class="badge badge-success2">&nbsp;</span>&nbsp;&nbsp;<label :label-cols="4" >Repeat/Duplicate Shipping Id </label>
                  </b-form-group> 
              </b-col>
                
                <b-col md="2">
                  <b-button variant="primary" @click="submitpicktocancel()" class="mr-2">
                      Submit
                    </b-button>
                    <b-button variant="danger" > Clear </b-button>
                </b-col>
                </b-row>
              </div>
              </b-card>
              <div >

              </div>



         
            </b-col>
          </b-row>
        <!-- </div> -->
      </div>
    </div>
             
</template>

<script>
import CONSTANTS from "@/utils/constants";

export default {
//     components: {
//     VueTagsInput,
//   },

    data: function(){
        return{
            pickupId:[],
            tags: [],
            avoidAddingDuplicates:false,
        }
    },


    created: function() {
        var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    },

     methods: {

        submitpicktocancel:function(){
          document.getElementById("overlayOTP").style.display = "block";
          var pickupId=[];
          for(var i = 0; i < this.tags.length; i++) {
              pickupId.push(this.tags[i].text);  
          }
       console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~>",pickupId)
       const Obj ={
        shippingid: pickupId,
        lastmodifiedby: `${userInfo.userfirstname}`+ ' ' + `${userInfo.userlastname}`,
        hub_id:`${userInfo.pickuplocationmasterid}`
       }
       
       var str= "Invalid shipment / delivery status is not pick-cancel";


        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/bulkPickcancelToCPC`, Obj)
        .then((result) => {
          document.getElementById("overlayOTP").style.display = "none";
          if(result.body.returnmsg == "Successful"){
              if(result.body.wrongShipment != "" || result.body.wrongShipment != null)
              {
                 this.$fire({
                    title: result.body.returnvalue,
                    type: "success",
                    timer: 30000
                  })
              }else{

                this.$fire({
                    title: result.body.returnvalue,
                    html: "<p>" + str + "</p>" + "" + result.body.wrongShipment + "",
                    type: "success",
                    timer: 30000
                  })

              }
               
               
          }else{
             this.$fire({
                title: result.body.returnvalue,
                html: "<p>" + str + "</p>" + "" + result.body.wrongShipment + "",
                type: "error",
                timer: 30000
               })

          }
          })
       
        }
     }

    
}

</script>

<style scoped>

#overlayOTP{
    position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
.loaderOTP{
    position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}
/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


</style>